export const LOGIN_REDIRECT_URL_PARAM = "login_redirect";
export const INVITATION_CODE_PARAM = "code";
//# sourceMappingURL=constants.js.map